import { API } from "aws-amplify";
import * as APITypes from "~/API";
import { deleteTransaction } from "~/graphql/mutations";
import { LoaderData } from "~/types";
import { EMPTY_TRANSACTION, getTransactionInfo } from ".";

export const terminateTransaction = async (
  transactionID: string
): Promise<LoaderData<APITypes.Transaction>> => {
  const transaction = await getTransactionInfo(transactionID);
  if (!canTerminateTransaction(transaction.data)) {
    return {
      success: false,
      data: EMPTY_TRANSACTION,
      error: "Transaction cannot be terminated",
    };
  }

  try {
    const transaction = (await API.graphql({
      query: deleteTransaction,
      variables: {
        input: {
          id: transactionID,
        },
      },
    })) as { data: APITypes.DeleteTransactionMutation };

    return {
      success: true,
      data: transaction.data?.deleteTransaction || EMPTY_TRANSACTION,
    };
  } catch (error) {
    console.error("Error terminating transaction", error);
    return {
      success: false,
      data: EMPTY_TRANSACTION,
      error: error,
    };
  }
};

export const canTerminateTransaction = (record: APITypes.Transaction) => {
  if (
    record.status !== APITypes.PaymentStatusType.Processing &&
    record.status !== APITypes.PaymentStatusType.Pending
  ) {
    return false;
  }

  switch (record.reason) {
    case APITypes.TransactionReason.Rent:
      return true;
    case APITypes.TransactionReason.Deposit:
      return true;
    case APITypes.TransactionReason.Fee:
      return true;
    case APITypes.TransactionReason.OtherPayment:
      return true;
    default:
      return false;
  }
};
